import { create } from 'zustand';

interface GlobalStore {
  formId: string;
  setFormId: (formId: string) => void;
}

export const useFormId = create<GlobalStore>(set => ({
  formId: '',
  setFormId: (formId: string) => set({ formId }),
}));
